import ContractStore from '../stores/ContractStore'
import Web3Store from '../stores/Web3Store'

export async function makeEvent(id, start_time, duration, teams, draw_possible) {
    return ContractStore.exec("EventsController", "makeEvent", [
        id,
        start_time,
        duration,
        teams,
        draw_possible
    ], {
        from: Web3Store.account,
        value: 10000
    });
}

export async function getActiveEvents() {
    let numberOfEvents = await getActiveEventsLength();
    let activeEventIds = new Array(numberOfEvents);
    let activeEvents = [];
    for (let eventIndex = 0; eventIndex < numberOfEvents; eventIndex++) {
        activeEventIds[eventIndex] = await ContractStore.call("Events", "getActiveEventId", [ eventIndex ]);
    }
    for (let eventId of activeEventIds) {
        activeEvents.push(await getEvent(eventId));
    }

    return activeEvents;
}

export async function getEvent(eventId) {
    let event = {};
    event.id = eventId;
    // Potentially unsafe to use integers
    event.totalAmountBet = parseInt(await ContractStore.call("Events", "getTotalAmountBet", [ eventId ]));
    event.cancelled = await ContractStore.call("Events", "getCancelled", [ eventId ]);
    event.startTime = parseInt(await ContractStore.call("Events", "getStart", [ eventId ]));
    event.duration = parseInt(await ContractStore.call("Events", "getDuration", [ eventId ]));
    event.endTime = event.startTime + event.duration;
    event.locked = await ContractStore.call("Events", "getLocked", [ eventId ]);
    return event;
}

export async function getActiveEventsLength() {
    return ContractStore.call("Events", "getActiveEventsLength", []);
}


export async function getWinner(eventId) {
    return ContractStore.call("Events", "getWinner", [eventId]);
}

export async function getThreshold(eventId) {
    return ContractStore.call("Events", "getThreshold", [eventId]);
}

export async function  cancelEvent(eventId) {
    console.log("cancelling event " + eventId);
    return ContractStore.exec("EventsController", "cancelEvent", [
        eventId
    ], {
        from: Web3Store.account
    });
}

export async function finalizeEvent(eventId) {
    console.log("finalizing event " + eventId);
    return ContractStore.exec("EventsController", "finalizeEvent", [
        eventId
    ], {
        from: Web3Store.account
    });
}


// WEBPACK FOOTER //
// ./src/contract/Events.js